import React from 'react'
import { useTranslation } from 'react-i18next'

import { ProductIds } from 'core/application/commons/config'

import useCurrentProduct from '../../common/hooks/useCurrentProduct'

const Dashboard: React.FC = () => {
  const { t: translate } = useTranslation('ee-dashboard')
  const product = useCurrentProduct()
  if (product.productId == ProductIds.Perks) {
    return <p>{translate('non-perks-ee-dashboard')}</p>
  } else {
    return (
      <p>
        You are not eligible to use the benefit. Contact your administrator or use the in-app chat if you have any
        questions.
      </p>
    )
  }
}

export default Dashboard
